
import * as React from "react"
import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    
    // Debug logging for textarea rendering
    React.useEffect(() => {
      console.log('[TEXTAREA-COMPONENT] Rendering textarea:', {
        className,
        hasRef: !!ref,
        timestamp: new Date().toISOString()
      });
    }, [className, ref]);

    const finalClassName = cn(
      "flex min-h-[80px] w-full rounded-lg border border-input bg-background px-3 py-2 text-sm text-foreground transition-colors focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
      className
    );

    console.log('[TEXTAREA-COMPONENT] Final className:', finalClassName);

    return (
      <textarea
        className={finalClassName}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
